import {useSearchParams} from "react-router-dom";
import {useState} from "react";
import useCustomPaging from "@/hooks/useCustomPaging";
import { convertLocalToWita } from '@/utils';

const useMultiDatePickerFilter = (key) => {
  const [searchParams] = useSearchParams()
  const [,,,,setFilters] = useCustomPaging()
  const startTimestampFilter = searchParams.get(key[0]) ?? ''
  const startTimestamp = startTimestampFilter
    ? convertLocalToWita(parseInt(startTimestampFilter, 10))
    : null
  const endTimestampFilter = searchParams.get(key[1]) ?? ''
  const endTimestamp = endTimestampFilter
    ? convertLocalToWita(parseInt(endTimestampFilter, 10))
    : null
  const initialStartDate = startTimestamp ? new Date(startTimestamp) : null
  const initialEndDate = endTimestamp ? new Date(endTimestamp) : null
  const [startDateState, setStartDateState] = useState(initialStartDate)
  const [endDateState, setEndDateState] = useState(initialEndDate)
  const handleChangeDate = (newDates) => {
    setStartDateState(newDates[0])
    setEndDateState(newDates[1])
    setFilters({
      startDate: `${newDates[0]?.getTime() ?? ''}`,
      endDate: `${newDates[1]?.getTime() ?? ''}`
    })
  }

  return [
    startTimestamp,
    endTimestamp,
    startDateState,
    endDateState,
    handleChangeDate
  ] as const
}

export default useMultiDatePickerFilter
